import React, { useContext } from 'react';
import { Box, FormControl, InputAdornment, makeStyles, OutlinedInput } from "@material-ui/core";
import { AppContext } from "../../contexts/AppContext";
import assets from "../../helpers/assets";
import Text from "./Text";
import Colors from '../../helpers/Colors';
import { useHistory } from 'react-router';
import Assets from '../../helpers/assets';
import {cleanUpAdminData} from "../../helpers/common-apis";

export function Header({ mode }) {
    const history = useHistory();
    const classes = useStyles();
    const { setLocalSearchText, localSearchText, authData, setAuth, setLoggedIn, kitchen } = useContext(AppContext);


    const onChangeSearch = (event) => {
        setLocalSearchText(event.target.value);
    }

    const onClickLogout = () => {
        setLoggedIn(false);
        setAuth(undefined);
        localStorage.setItem('dashboard_user', '');
        cleanUpAdminData();
        history.replace("/login");
    }

    const onClickSettings = () => {
        history.replace('/dispatcher/settings')
    }

    const onBackArrowClick = () => {
        history.replace("/dispatcher");
    }

    const onClickRemoveSearch = () => {
        setLocalSearchText('');
    }

    return (
        <Box className={classes.container}>
            {mode == 'settings' && <Box className={classes.settingsSection} style={{ minWidth: '33%' }}>
                <Box
                    onClick={onBackArrowClick}
                    className={classes.backArrowBtn}>
                    <img
                        src={assets.backArrow.default}
                        alt="Back"
                        className={classes.backArrow} />
                </Box>
                <Text className={classes.settingsText}>Settings</Text>
            </Box>}
            {mode != 'settings' &&
                    <Box className={classes.userSection}>
                        <Box className={classes.userBox}>
                            <Text className={classes.userText}>{authData?.username?.charAt(0)?.toUpperCase() || '-'}</Text>
                        </Box>
                        <Box className={classes.logoBox}>
                            <img
                                src={Assets.logoBlack.default}
                                alt=""
                                className={classes.logoBlack}
                            />
                        </Box>
                    </Box>}
            <Box className={classes.locationSection} style={mode == 'settings' ? { justifyContent: 'center', paddingRight: 0, } : {}}>
                <Box className={classes.locationBox}>
                    <img
                        src={assets.location.default}
                        alt=""
                        className={classes.locationIcon}
                    />
                    <Text className={classes.locationText}>
                        {kitchen && kitchen.name}
                    </Text>
                    <Text className={classes.locationDetailText}>
                        {kitchen && kitchen.address}
                    </Text>
                </Box>

            </Box>
            {mode != 'settings' && <Box className={classes.searchSection}>

                <FormControl
                    fullWidth
                    className={classes.searchInputFormControl}
                    variant="standard"
                >
                    <OutlinedInput
                        placeholder="Search"
                        value={localSearchText}
                        onChange={onChangeSearch}
                        startAdornment={
                            <InputAdornment position="start">
                                <img
                                    src={assets.search.default}
                                    alt=""
                                    className={classes.searchIcon}
                                />
                            </InputAdornment>
                        }
                        endAdornment={
                            <Box
                                onClick={onClickRemoveSearch}
                                className={classes.closeButtonContainer}>
                                <img
                                    src={assets.close.default}
                                    alt=""
                                    className={classes.closeIcon}
                                />
                            </Box>
                        }
                        labelWidth={0}
                        className={classes.searchInput}
                    />
                </FormControl>
            </Box>}
            {mode != 'settings' && !kitchen.multiTenant && <Box
                onClick={onClickSettings}
                className={classes.logoutSection}
            >
                <Box className={classes.logoutButton}>
                    <img
                        src={assets.settings.default}
                        alt="Settings"
                        className={classes.logo}
                    />
                </Box>
            </Box>}
            <Box
                onClick={onClickLogout}
                className={classes.logoutSection}
                style={mode == 'settings' ? { minWidth: '33%', marginRight: '20px' } : {}}
            >
                <Box className={classes.logoutButton}>
                    <img
                        src={assets.logout.default}
                        alt=""
                        className={classes.logo}
                    />
                </Box>
            </Box>
        </Box>
    );
}


export const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        direction: 'row',
        width: '100%',
        height: 60,
        marginBottom: 10
    },
    logo: {
        height: 20,
        width: 20,
        objectFit: 'contain',
    },
    logoBlack: {
        height: 30,
        width: 250,
        objectFit: 'contain',
    },
    settingsSection: {
        display: 'flex',
        flex: 2,
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    settingsText: {
        fontSize: 24,
        color: Colors.textColor,
        fontWeight: '500',
        fontFamily: 'SFProDisplay-Medium',
    },
    backArrowBtn: {
        margin: 14,
        cursor: 'pointer'
    },
    backArrow: {
        height: 24,
        width: 24,
        cursor: 'pointer',
        objectFit: 'contain',
    },
    searchIcon: {
        height: 16,
        width: 16,
        objectFit: 'contain',
    },
    locationIcon: {
        height: 18,
        width: 15,
        objectFit: 'contain',
        marginRight: 10,
    },
    searchInput: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #EDEDED',
        },
        '& .MuiInputBase-input': {
            fontSize: 16,
            fontFamily: 'DINNextLTPro-Regular'
        },
        fontFamily: 'DINNextLTPro-Regular'
    },
    searchInputFormControl: {
        '& .MuiInputBase-root': {
            borderRadius: 4,
        },
        '& .MuiOutlinedInput-adornedStart': {
            height: 45,
        },
        width: 266
    },
    locationText: {
        fontSize: 16,
        color: Colors.textColor,
        fontWeight: '600',
        opacity: 0.8,
        marginRight: 10,
        fontFamily: 'SFProDisplay-Bold',
    },
    locationDetailText: {
        fontSize: 14,
        color: Colors.textColor,
        opacity: 0.63,
        fontFamily: 'SFProDisplay-Medium',
    },
    userText: {
        color: Colors.white,
        fontFamily: 'SFProDisplay-Medium',
    },
    userSection: {
        display: 'flex',
        flex: 2,
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    logoSection: {
        display: 'flex',
        flex: 2,
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    userBox: {
        height: 35,
        width: 35,
        borderRadius: 20,
        backgroundColor: Colors.blue,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    logoBox: {
        height: 35,
        width: 35,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 45
    },
    locationSection: {
        display: 'flex',
        flex: 3,
        direction: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: 10,
    },
    locationBox: {
        display: 'flex',
        alignItems: 'center',
        height: 45,
        padding: 16,
        borderRadius: 4,
        border: '1px solid #EDEDED',
    },
    searchSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    logoutSection: {
        height: '100%',
        width: 50,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        cursor: 'pointer',
        marginLeft: 5
    },
    logoutButton: {
        height: 45,
        width: 45,
        borderWidth: 1,
        borderRadius: 4,
        border: '1px solid #EDEDED',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    closeIcon: {
        height: 16,
        width: 16,
        objectFit: 'contain',
    },
    closeButtonContainer: {
        cursor: 'pointer',
        height: 45,
        width: 35,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
}));
